// extracted by mini-css-extract-plugin
export default {"invitations__banner":"Invitations_invitations__banner__68mQK","invitations__banner__img":"Invitations_invitations__banner__img__NMgbG"};